import React from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import useDarkMode from "../hooks/useDarkMode";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [theme, setTheme] = useDarkMode();

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <header className="h-[56px] md:h-[80px] shadow-md w-full px-4 sm:px-6 lg:px-10 xl:px-16 fixed top-0 left-0 right-0 z-50 bg-white dark:bg-containerColor text-textColor dark:text-white flex justify-between items-center">
    <Link to="/">
      <h1 className="text-[14px] sm:text-[18px] md:text-[22px] font-extrabold">
        Where in the world?
      </h1>
    </Link>

      <button
        onClick={toggleTheme}
        className="flex items-center gap-2 text-[12px] sm:text-[14px] md:text-[16px] font-semibold"
      >
        {theme === "light" ? <FiMoon size={18} /> : <FiSun size={18} />}
        <span>{theme === "light" ? "Dark Mode" : "Light Mode"}</span>
      </button>
    </header>
  );
};

export default Navbar;
